import React from 'react';

import * as S from './styles';

const Slide2: React.FC = () => {
  return (
    <S.Container>
      <S.Image />
      <S.Subtitle>
        Alice (sentada) usa macacão, Bold Strap, R$ 3.950. Luvas, Moun, R$ 229.
        <br />
        <br />
        Em pé: jardineira, B.Luxo, R$ 580. Regata, Intimissimi, R$ 199. Macacão
        (usado como capa), Isabel Marant, R$ 8.090.
      </S.Subtitle>
    </S.Container>
  );
};

export { Slide2 };
